import React from 'react';
import { Col, Row } from '../../../../../components/base/BootstrapComponents/BootstrapComponents';
import Switches from '../../../../../components/fields/Switches/Switches';
import { PROCEDURE_TYPE, USER_TYPE } from '../../../../../configs';
import { infoFormatterIntl } from '../../../../../utils/formatters';
import FileView from '../../../../../components/fields/FileInput/FileView';

export default function OgrnipView(props) {
  const {
    fieldsValidation = {},
    procedure,
    applicantType,
    currentApplication = {},
  } = props;

  const applicant_new = currentApplication?.applicant_new || {};
  const files = currentApplication?.files || [];
  const registry_subject = currentApplication?.registry_subject || {};

  const { ogrn } = applicant_new;
  const ogrip_change_document = files.find(item => item.collection_name === 'ogrip_change_document');

  const hasOgrnData = !!ogrn || ogrn === null;

  if (![PROCEDURE_TYPE.PROCEDURE_1227_8].includes(procedure) || applicantType !== USER_TYPE.INDIVIDUAL_ENTREPRENEUR) {
    return null;
  }

  const {
    ogrn: oldOgrn,
  } = registry_subject;

  return (
    <>
      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => {},
              value: hasOgrnData,
            }}
            label="Изменился ОГРНИП"
          />
        </Col>
      </Row>
      {hasOgrnData && (
        <>
          <Row className="row-cols-2">
            {infoFormatterIntl(
              'old.ogrnip',
              oldOgrn,
              fieldsValidation,
              'ogrn',
            )}
          </Row>
          <Row className="row-cols-2">
            {infoFormatterIntl(
              'new.ogrnip',
              ogrn,
              fieldsValidation,
              'applicant_new.ogrn',
            )}
          </Row>
          <Row className="row-cols-1">
            {infoFormatterIntl(
              'media.ogrip_change_document',
              ogrip_change_document ? (
                <FileView
                  readOnly
                  withoutMime
                  withoutHr
                  files={[ogrip_change_document]}
                />
              ) : null,
              fieldsValidation,
              '',
              6,
            )}
          </Row>
        </>
      )}
      <div className="hr-row mt-3" />
    </>
  );
}
